import { i18nNsFactory } from '@atlas-frontend/i18n';
import { Flex } from 'antd';
import { FC, useCallback, useState } from 'react';
import styled from 'styled-components';
import { Padding } from '../../common/components';
import {
  CollapsedIcon,
  ExpandedIcon,
} from '../../common/components/CollapsibleHeader';
import { AlgorithmInfo, RenderRow } from './AlgorithmInfo';
import { AlgorithmStatus } from './AlgorithmStatus';
import { AlgorithmExtendedType } from './schema/types';
import { AlgorithmSourceFormDataType } from './sources/schema/types';
import { AlgorithmMapping } from './utils';
import translations from './AlgorithmCollapsibleHeader.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory('algorithms-view');
addTranslations(translations);

export type AlgorithmCollapsibleHeaderProps = {
  algorithm: AlgorithmExtendedType;
  sourcesById: Map<number, AlgorithmSourceFormDataType>;
  mappingsById: Map<number, AlgorithmMapping>;
  alternativeCode?: number;
  isEditMode: boolean;
  renderRow?: RenderRow;
} & (
  | {
      isExpanded: boolean;
      onToggleExpanded: () => void;
    }
  | {
      isExpanded?: never;
      onToggleExpanded?: never;
    }
);

export const AlgorithmCollapsibleHeader: FC<AlgorithmCollapsibleHeaderProps> = (
  props
) => {
  const {
    algorithm,
    sourcesById,
    mappingsById,
    alternativeCode,
    isEditMode,
    onToggleExpanded,
    renderRow,
  } = props;
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle = useCallback(() => {
    setIsExpanded(!isExpanded);
  }, [isExpanded]);

  const ToggleIcon =
    props.isExpanded ?? isExpanded ? ExpandedIcon : CollapsedIcon;

  return (
    <Flex vertical gap="large" id={`group-algorithm-${algorithm.code}`}>
      <HeaderWrapper
        justify="space-between"
        onClick={onToggleExpanded ?? handleToggle}
      >
        <Flex gap="small">
          <ToggleIcon />
          <strong>{t('algorithm.label')}</strong>
          <span>{algorithm.code}</span>
        </Flex>
        <AlgorithmStatus statusId={algorithm.statusId} />
      </HeaderWrapper>
      {(props.isExpanded ?? isExpanded) && (
        <Padding left>
          <AlgorithmInfo
            algorithm={algorithm}
            sourcesById={sourcesById}
            mappingsById={mappingsById}
            alternativeCode={alternativeCode}
            showTargetEdit={isEditMode}
            renderRow={renderRow}
          />
        </Padding>
      )}
    </Flex>
  );
};
const HeaderWrapper = styled(Flex)`
  cursor: pointer;
`;
